export const locale = {
  stocqHOS: "STOCQ Head Office System",
  hos: "Head Office System",
  startShift: "Shift Start Date & Time",
  endShift: "Shift End Date & Time",
  endOfShift: "End of Shift",
  shiftNumber: "Shift Number",
  cashier: "Cashier",
  totalFuelSales: "Total Fuel Sales",
  approve: "Approve",
  shiftStatus: "Shift Status",
  totalSales: "Total Sales",
  syncProgress: "Sync Progress",
  shiftRecords: "Shift Records",
  shiftDetails: "Shift Details",
  shiftReportDetails: "Shift Report Details",
  wetStockInventory: "Wet Stock Inventory",
  salesAndInventory: "Sales and Inventory",
  fuelSales: "Fuel Sales",
  fuelDeliveries: "Fuel Deliveries",
  fuelVariance: "Fuel Variance",
  dryStockSales: "Dry Stock Sales",
  dryStock: "Dry Stock",
  dryStockInventory: "Dry Stock Inventory",
  beginningInventory: "Beginning Inventory (Dipstick)",
  endingInventory: "Ending Inventory (Dipstick)",
  didNotPerformDipstickReading: "Did not perform dipstick reading",
  cashAndNonCash: "Cash and Non-Cash",
  shiftDate: "Shift Date",
  shiftDuration: "Shift Duration",
  shiftDateRange: "Shift Date Range",
  shiftTime: "Shift Time",
  shiftAttendance: "Shift Attendance",
  agency: "Agency",
  started: "Started",
  ended: "Ended",
  closed: "Closed",
  crewOnDuty: "Crew On Duty",
  pumpNumber: "Pump Number",
  pumpNo: "Pump No.",
  beginning: "Beginning",
  salesInLiters: "Sales In Liters",
  pumpPrice: "Pump Price",
  pumpDiscount: "Pump Discount",
  beginningTotalizer: "Beginning Totalizer",
  endingTotalizer: "Ending Totalizer",
  otherDiscounts: "Other Discounts",
  finalAmount: "Final Amount",
  totalizerDifference: "Totalizer Difference",
  totalizerVariance: "Totalizer Variance (%)",
  deliveryId: "Delivery ID",
  dateAndTime: "Date and Time",
  poReferenceNumber: "PO Reference Number",
  plateNumber: "Plate Number",
  witnesses: "Witnesses",
  variant: "Variant",
  unitPrice: "Unit Price",
  beforeReceivingCm: "Before Receiving (cm)",
  beforeReceivingL: "Before Receiving (L)",
  quantityDelivered: "Quantity Delivered",
  afterReceivingCm: "After Receiving (cm)",
  afterReceiving: "After Receiving (L)",
  ugt: "UGT",
  ugts: "UGTs",
  quantitySold: "Quantity Sold",
  records: "Records",
  nonCashSummary: "Non-Cash Summary",
  nonSaleTransactions: "Non-Sale Transactions",
  nonCashTransactions: "Non-Cash Transactions",
  cashTransactions: "Cash Transactions",
  expenses: "Expenses",
  cashOnHand: "Cash On Hand",
  netCashSummary: "Net Cash Summary",
  bankDeposits: "Bank Deposits",
  keyAccountCollections: "Key Account Collections",
  discounts: "Discounts",
  discount: "Discount",
  pump: "Pump",
  keyword: "Keyword",
  remarks: "Remarks",
  remarksHo: "Remarks: (HOS Admin)",
  totalAmount: "Total Amount",
  transactionType: "Transaction Type",
  referenceNo: "Reference No.",
  quantity: "Quantity",
  transactionId: "Transaction ID",
  refName: "Ref Name",
  paymentMethod: "Payment Method",
  expenseId: "Expense ID",
  typeOfExpense: "Type of Expense",
  denomination: "Denomination",
  safeDrops: "Safe Drops",
  depositId: "Deposit ID",
  depositType: "Deposit Type",
  collectionId: "Collection ID",
  collectionDateAndTime: "Collection Date and Time",
  siNumSoa: "SI Number / SOA",
  keyAccountName: "Key Account Name",
  editDetails: "Edit details",
  deactivate: "Deactivate",
  add: "Add",
  sorryNoResultFound: "Sorry, no results found",
  weCouldNotFindAMatchForSearchCriteria: "We could not find a match for your search criteria.",
  pleaseTryADifferentOne: "Please try a different one.",
  cancel: "Cancel",
  pleaseEnterAValidMobileNumber: "Please enter a valid mobile number.",
  pleaseEnterAValidTelephoneNumber: "Please enter a valid telephone number.",
  all: "All",
  allFuelProducts: "All Fuel Products",
  clearAll: "Clear All",
  applyFilters: "Apply Filters",
  name: "Name",
  status: "Status",
  email: "Email",
  filters: "Filters",
  emailAddress: "Email Address",
  password: "Password",
  rememberMe: "Remember Me",
  logIn: "Log In",
  incorrectEmailOrPassword: "Incorrect email or password. Please try again.",
  pleaseEnterAValidEmailAddress: "Please enter a valid email address.",
  amount: "Amount",
  expired: "Expired",
  diesel: "Diesel",
  gas91: "Gas 91",
  gas95: "Gas 95",
  gas97: "Gas 97",
  product: "Product",
  onlyAlphaNumericAllowedAndSpecial:
    "Only Alphanumeric characters and the following special symbol ( - , . , spaces ) are allowed.",
  driverLicenseIdIsInvalid: "This driver license ID is invalid.",
  date: "Date",
  to: "to",
  gotIt: "Got It",
  onlyNumericAreAllowed: "Only numeric characters are allowed.",
  ohSnap: "Oh snap!",
  somethingWentWrongPleaseTryAgain: "Something went wrong. Please try again.",
  tryAgain: "Try Again",
  searchOrSelect: "Search or select",
  salesDiscount: "Sales Discount",
  salesPremium: "Sales Premium",
  regularDiscount: "Regular Discount",
  seniorDiscount: "Senior Discount",
  pwdDiscount: "PWD Discount",
  total: "Total",
  pay: "Pay",
  exclamatedSuccess: "Success!",
  oops: "Oops! Something went wrong",
  pleaseRefreshYourBrowser: "Please refresh your browser",
  back: "Back",
  backToHomePage: "Back to Home Page",
  okayGotIt: "Okay, got it!",
  use8CharWithMix: "Use 8 or more characters with a mix of letters, numbers and symbols",
  goToLogin: "Go to Login",
  viewDetails: "View Details",
  reportGenerated: "Report is being generated",
  browseYourFile: "Browse Your Files",
  replace: "Replace",
  pleaseSelectCSVFile: "Please select a .csv file",
  downloadSingle: "Download",
  downloads: "Downloads",
  dateOfGeneration: "Date of Generation",
  yourReportIsBeingPrepared: "Your report is being prepared",
  youCanContinueUsingHosWhileWeGenerateYourReport:
    "You can continue using HOS while we generate your report. Open Downloads to check its progress and download it when ready.",
  openDownloads: "Open Downloads",
  delete: "Delete",
  deleteExport: "Delete Export?",
  deleteExportMessage:
    "Are you sure you want to delete {0} from Downloads? This action cannot be undone. The original report data will not be affected.",
  exportDeleted: "Export Deleted",
  preparing: "Preparing…",
  exportCanceled: "Canceled",
  noExportsYet: "No exports yet",
  exportAReportToSeeItsProgressAndDownloadItHere:
    "Export a report to see its progress and download it here.",
  noMatchingExportsFound: "No matching exports found.",
  tryChangingYourFilters: "Try changing your filters.",
  theExportedFileHasBeenDeletedFromDownloads: "The exported file has been deleted from Downloads.",
  lastEdited: "Last edited on ",
  export: "Export",
  logout: "Logout",
  promos: "Promos",
  allCashiers: "All Cashiers",
  currentShift: "Current Shift",
  coins: "Coins",
  closeShift: "Close Shift",
  employee: "Employee",
  addEmployee: "Add Employee",
  employeePosition: "Employee Position",
  employeeAssigned: "Employee Assigned",
  employeeToShoulderShortage: "Employee to Shoulder Shortage",
  amountToShoulder: "Amount to Shoulder",
  actualCashOnHand: "Actual Cash on Hand",
  expectedCashOnHand: "Expected Cash on Hand",
  beginningBalance: "Beginning Balance",
  cashSales: "Cash Sales",
  successMessageModalCloseShift: "You have successfully ended your shift",
  birReport: "BIR Report",
  salesSummaryReport: "Sales Summary Report",
  zReadCount: "Z-Read Counter",
  ending: "Ending",
  beginningAccumulatedSalesInvoice: "Beginning Accumulated Sales Invoice",
  endingAccumulatedSalesInvoice: "Ending Accumulated Sales Invoice",
  beginningAccumulatedGrossSales: "Beginning Accumulated Gross Sales",
  endingAccumulatedGrossSales: "Ending Accumulated Gross Sales",
  salesCount: "Sales Count",
  grossTotal: "Gross Total",
  vatableSales: "VATable Sales",
  vatAmount: "VAT Amount",
  vatExempt: "VAT Exempt",
  zeroRatedSales: "Zero-Rated Sales",
  netTotal: "Net Total",
  employeeOnDuty: "Employee on Duty",
  discountReport: "Discount Report",
  salesTransactioHistoryReport: "Sales Transaction History Report",
  invoiceNo: "Invoice No.",
  description: "Description",
  sku: "SKU",
  itemCode: "Item Code",
  qty: "QTY",
  discountAmount: "Discount Amount",
  productDescription: "Product Description",
  invoice: "Invoice",
  arrangeBy: "Arrange By",
  grossSales: "Gross Sales",
  customerType: "Customer Type",
  customerId: "Customer ID",
  customerName: "Customer Name",
  grossAmount: "Gross Amount",
  totalDiscount: "Total Discount",
  vatSales: "VATable Sales",
  totalAmountDue: "Total Amount Due",
  salesInvoiceNo: "Sales Invoice No.",
  transient: "Transient",
  systemCorrection: "System Correction",
  keyAccount: "Key Account",
  promoDate: "Promo Date",
  promoName: "Promo Name",
  promoType: "Promo Type",
  promoAmount: "Promo Amount",
  transactionCap: "Transaction Cap",
  participatingStations: "Participating Stations",
  createByORCreatedOn: "Created By/Created On",
  reasonRemarks: "Reason/Remarks",
  actions: "Actions",
  discountPerLiter: "Discount Per Liter",
  discountPerTransaction: "Discount Per Transaction",
  discountPerUnit: "Discount Per Unit",
  percentDiscount: "Percent Discount",
  upcoming: "Upcoming",
  ongoing: "Ongoing",
  viewAll: "View All",
  addPromo: "Add Promo",
  cancelPromo: "Cancel Promo",
  cancelPromoContent: "You are cancelling {0} promo. input the reason below to proceed.",
  reason: "Reason",
  incorrectDetails: "Incorrect Details",
  duplicatePromo: "Duplicate Promo",
  others: "Others",
  promoSuccessfullyCanceled: "Promo Successfully Cancelled",
  promoSuccessfullyCanceledContent: "This promo has been successfully cancelled.",
  edit: "Edit",
  create: "Create",
  view: "View",
  promo: "Promo",
  promoDetails: "Promo Details",
  promoDuration: "Promo Duration",
  selectDates: "Select Date(s)",
  leavePageQuestion: "Leave Page?",
  leavePageQuestionContent:
    "Are you sure you want to leave? Your changes will not be saved once you exit.",
  continueEditing: "Continue editing",
  leavePage: "Leave page",
  selectProduct: "Select Product",
  selectProducts: "Select Products",
  selectPromo: "Select Promo",
  productName: "Product Name",
  productType: "Product Type",
  save: "Save",
  addProduct: "Add Product",
  nSelected: "{0} Selected",
  dateOfLastUpdated: "Date of Last Updated",
  createdBy: "Created By",
  createdOn: "Created On",
  typeRemarks: "Type remarks",
  selectStations: "Select Stations",
  editStations: "Edit Stations",
  stationCode: "Station Code",
  stationType: "Station Type",
  stationName: "Station Name",
  stationNameCode: "Station Name/Code",
  stations: "Stations",
  addStation: "Add Station",
  saveChanges: "Save Changes",
  createPromo: "Create Promo",
  successPromoCreated: "Promo has been successfully created.",
  confirmSaving: "Are you sure you want to create a promo with these details?",
  confirmChanges: "Are you sure you want to save the changes you made?",
  changesSuccess: "Your changes has been successfully saved.",
  success: "Success!",
  yes: "Yes",
  no: "No",
  products: "Products",
  promoStatus: "Promo Status",
  participating: "Participating",
  editPromo: "Edit Promo",
  canceledBy: "Cancelled By",
  typeHere: "Type here..",
  selectPromoType: "Select Promo Type",
  subscription: "Subscription",
  onboardedBy: "Onboarded By",
  onboardedOn: "Onboarded On",
  dateOnboarded: "Date Onboarded",
  pending: "Pending",
  forAccountingReview: "For Accounting Review",
  acknowledged: "Acknowledged",
  active: "Active",
  activate: "Activate",
  deactivated: "Deactivated",
  manualMode: "Manual Mode",
  deactivateStation: "Deactivate Station",
  activateStation: "Activate Station",
  deactivateStationContent:
    "You are about to deactivate this station. Input the reason below to proceed",
  activateStationContent: "Are you sure you want to activate station {0}?",
  yesActivate: "Yes, Activate",
  endOfContract: "End of Contract",
  stationClosed: "Station Closed",
  updateStationStatusSuccessMessage: "You have successfully {0} this station.",
  noLimit: "No Limit",
  promoTime: "Promo Time",
  maxDiscount: "Maximum Discount",
  minPurchase: "Minimum Purchase",
  minDateError: "Invalid Min. date.",
  ok: "OK",
  stationDetails: "Station Details",
  posDetails: "POS Details",
  users: "Users",
  birTaxpayerName: "BIR 2303 Taxpayer Name",
  birRegisteredAddress: "BIR 2303 Registered Address",
  birTinBranchCode: "BIR 2303 Tin & Branch Code",
  opening: "Opening",
  closing: "Closing",
  latitude: "Latitude",
  longitude: "Longitude",
  pumpBrands: "Pump Brands",
  safeDropThreshold: "Safe Drop Threshold",
  serialNumber: "Serial Number",
  machineIdNumber: "Machine Identification Number",
  ptuNumber: "PTU Number",
  liters: "Liters",
  addUgt: "Add UGT",
  username: "Username",
  position: "Position",
  defaultAmount: "Default Amount",
  promoCap: "Promo Cap",
  editStation: "Edit Station",
  viewStation: "View Station",
  promoDateAndTime: "Promo Date/Time",
  station: "Station",
  selectPromos: "Select Promos",
  overridePrice: "Override Price",
  continue: "Continue",
  firstName: "First Name",
  lastName: "Last Name",
  userNotFound: "Username does not exist",
  duplicateUsername: "The username is already in use.",
  stationAddedSuccessfully: "Station Added Successfully.",
  addUser: "Add User",
  editProduct: "Edit Product",
  set24Hours: "Set to 24 Hours",
  onBoardStation: "Are you sure you want to onboard {0}?",
  successStation: "Station has been successfully added.",
  dryStockProducts: "Dry Stock Products",
  serviceAdvisor: "Service Advisor",
  stationHead: "Station Head",
  technician: "Technician",
  maxTransactionStacking: "Max Transaction Stacking",
  ugtNumber: "UGT Number",
  birTin: "BIR 2303 TIN & Branch Code",
  defaultPrice: "Default Price",
  clear: "CLEAR",
  productVariant: "Product Variant",
  tapEnterToCreate: "Tap enter to create",
  subscriptionType: "Subscription Type",
  dateTime: "Date & Time",
  lastChecked: "Last Checked",
  lastTransaction: "Last Transaction",
  connectedToPTS: "Connected to PTS",
  connectedToPump: "Connected to Pump",
  online: "Online",
  offline: "Offline",
  fuel: "Fuel",
  lubricants: "Lubricants",
  lpg: "LPG",
  productCategory: "Product Category",
  productImage: "Product Image",
  browseYourFiles: "Browse your files",
  quantityDecimalPlaces: "Quantity Decimal Places",
  businessLocations: "Business Locations",
  unitOfMeasurement: "Unit of Measurement",
  viewProduct: "View Product",
  saveProduct: "Save Product?",
  confirmSaveProduct: "Are you sure you want to save this product?",
  productSaved: "Product Saved",
  successfullySavedProduct: "You have successfully saved this product.",
  deleteProduct: "Delete Product",
  confirmDeleteProduct: "Are you sure you want to delete this product?",
  productDeleted: "Product Deleted",
  successfullyDeletedProduct: "You have successfully deleted the product.",
  cannotDeleteProduct: "Cannot Delete Product",
  productHasExistingTransactionError: "Product has an existing transaction and cannot be deleted.",
  productHasExistingDeliveryLogsError: "Product has existing delivery logs and cannot be deleted.",
  selectAll: "Select All",
  searchOrCreate: "Search or Create here",
  selectOne: "Select One",
  invalidFileType: "Invalid file type.",
  category: "Category",
  productCode: "Product Code",
  imageUploadFailed: "Image upload failed",
  imageErrorContent: "Please upload a valid image file in JPEG or PNG format, no larger than 5MB.",
  invalidDimensions: "Image dimensions must be less than 100px.",
  invalidImage: "The selected file is not a valid image.",
  importCSV: "Import CSV",
  importProductsByCSV: "Import Products by CSV",
  dragAndDropFilesToUploadOr: "Drag and drop files to upload or",
  replaceFile: "Replace file",
  addFile: "Add File",
  pleaseUploadValidCSVFile: "Please upload a valid CSV file.",
  emptyItemsCSV: "CSV file is empty or invalid.",
  invalidImport: "Invalid Import",
  invalidImportedEntriesMessage:
    "Some of the entries imported are invalid. Please try again and make sure to follow the format.",
  region: "Region",
  island: "Island",
  weCouldNotFindAMatchForSelectedFilters: "We could not find a match for your selected filters.",
  and: "and",
  priceLOCQForConsumerStation: "PriceLOCQ for Consumer Station",
  priceLOCQForBusinessStation: "PriceLOCQ for Business Station",
  notOnboarded: "Not Onboarded",
  hidden: "Hidden",
  orderSummary: "Order Summary",
  inventory: "Inventory",
  processing: "Processing",
  forApproval: "For Approval",
  forRevision: "For Revision",
  canceled: "Cancelled",
  reject: "Reject",
  rejected: "Rejected",
  forDelivery: "For Delivery",
  delivered: "Delivered",
  orderId: "Order ID",
  amountInKL: "Amount in KL",
  amountInPhp: "Amount in PHP",
  purchaseOrderNumber: "Purchase Order No.",
  salesOrderNumber: "Sales Order No.",
  orderSummaryNumber: "Order Summary Number",
  orderRecipient: "Order Recipient",
  preferredDeliveryDateTime: "Preferred Delivery Date and Time",
  stationLevelRemarks: "Station-Level Remarks",
  itemOrder: "Item Order",
  currentInventoryLevel: "Current Inventory Level",
  orderVolume: "Order Volume",
  requestRevision: "Request Revision",
  approved: "Approved",
  confirmApproval: "Confirm Approval?",
  confirmApprovalMessage:
    "Are you sure you want to approve this purchase order? This action cannot be undone.",
  purchaseOrderApproved: "Purchase Order Approved!",
  purchaseOrderApprovedMessage: "The purchase order has been successfully approved.",
  rejectPurchaseOrder: "Reject Purchase Order?",
  rejectPurchaseOrderMessage: "You are about to reject {0}.",
  inputReasonToProceed: "Input the reason below to proceed.",
  rejectOrderSuccessfully: "Order Successfully Rejected!",
  rejectOrderSuccessMessage: "You have successfully rejected the order.",
  reviseOrderSuccessfully: "Request for Revision Successful!",
  reviseOrderSuccessMessage: "You have successfully requested to revise the Purchase Order.",
  requestRevisionTitle: "Request Revision to Purchase Order",
  requestRevisionMessage: "You are about to request revision to {0}.",
  rejectReason: "Reject Reason",
  requestRevisionReason: "Request Revision Reason",
  currentInventoryLevelInfo:
    "Displayed value is derived from totalizer liters sold. No dipstick reading recorded for the current date.",
  proceed: "Proceed",
  createdDateAndTime: "Created Date and Time",
  minimumAmount: "Minimum allowed input is 1 peso.",
  recordedVolume: "Recorded Volume",
  discountPremium: "Discount/Premium",
  addRemarks: "Add Remarks",
  typeYourRemarks: "Type your remarks here",
  viewRemarks: "View Remarks",
  adjustmentTotal: "Adjustment Total",
  promoSummary: "Promo Summary",
  transactionCount: "Transaction Count",
  volumeSold: "Volume Sold",
  qtySold: "Qty Sold",
  finalAmountPaid: "Final Amount Paid",
  receipt: "Receipt",
  slipPreview: "Bank Slip",
  varianceAdjustment: "Variance Adjustment",
  adjustmentType: "Adjustment Type",
  dryStockMovement: "Dry Stock Movement",
  type: "Type",
  actualBeginningInventory: "Actual Beginning Inventory",
  delivery: "Delivery",
  sales: "Sales",
  returns: "Returns",
  expectedEndingInventory: "Expected Ending Inventory",
  actualEndingInventory: "Actual Ending Inventory",
  variance: "Variance",
  lubricantSales: "Lubricant Sales",
  lpgSales: "LPG Sales",
  dryStockDeliveries: "Dry Stock Deliveries",
  dryStockLubricants: "Dry Stock Sales - Lubricants",
  dryStockLPG: "Dry Stock Sales - LPG",
  stocq: "Stocq",
  totalizerDiffActual: "Totalizer Diff Actual",
  totalizerVarianceActual: "Totalizer Variance (%) Actual",
  afterReceivingL: "After Receiving (L)",
  beginningTotalizerStocq: "Beginning Totalizer STOCQ",
  endingTotalizerStocq: "Ending Totalizer STOCQ",
  beginningTotalizerActual: "Beginning Totalizer Actual",
  endingTotalizerActual: "Ending Totalizer Actual",
  premium: "Premium",
  transactionNo: "Transaction No.",
  noOfTransactions: "No. of Transactions",
  shiftReportDetails: "Shift Report Details",
  action: "Action",
  beforeReceiving: "Before Receiving",
  shirtReport: "Shift Report",
};

export default Object.freeze(locale);
